import React from "react";
import IconGlyph from "@/bit/components/components.icon-glyph";
import SmartWifiDevicesFake from "@/components/Fakes/smart-wifi-fake/device-box-fake"

const SmartWifiFake = () => {
  return (
    <>
      <section className="container smart-wifi-fake">
        <div className="smart-wifi-fake--column-1">
          <div className="smart-wifi-fake--column-1--header">
            <div className="skeleton smart-wifi-fake--column-1--header--title" />
            <div className="smart-wifi-fake--column-1--header--selector">
              <div className="skeleton smart-wifi-fake--column-1--header--selector--text" />
              <IconGlyph id="cheuron-down-m" height="16px" color="movistarBlue" />
            </div>
          </div>
          <SmartWifiDevicesFake />
        </div>
      </section>
      <style jsx>{`
        .smart-wifi-fake {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          &--column-1 {
            &--header {
              display: flex;
              flex-direction: column;
              gap: 1rem;
              margin-bottom: 1rem;
              &--title {
                height: 18px;
                width: 200px;
              }
              &--selector {
                display: flex;
                flex-direction: row;
                padding: 1.5rem;
                justify-content: space-between;
                align-items: center;
                border: 1px solid #ddd;
                border-radius: 4px;
                &--text {
                  height: 16px;
                  width: 180px;
                }
              }
            }
          }
        }
        @media (min-width: 768px) {
          .smart-wifi-fake {
            flex-direction: row;
            justify-content: space-between;
            &--column-1 {
              width: 70%;
            }
          }
        }
      `}</style>
    </>
  );
};

export default SmartWifiFake;
